import { render, staticRenderFns } from "./agentWechatOrder.vue?vue&type=template&id=dbf78912&"
import script from "./agentWechatOrder.vue?vue&type=script&lang=js&"
export * from "./agentWechatOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentWechatOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports